var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPromoCode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.01 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_price_tag_2631649",
    "data-name": "noun price tag 2631649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26439",
    "data-name": "Group 26439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26438",
    "data-name": "Group 26438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26433",
    "data-name": "Group 26433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26432",
    "data-name": "Group 26432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46841",
    "data-name": "Path 46841",
    d: "M884.21,454.77a3.5,3.5,0,0,0-3.36-2.83,4.93,4.93,0,0,0-.66.07l-.45.11-1.22.25a5.7,5.7,0,0,0,.66,2.12.25.25,0,0,1,.1.17,1.1,1.1,0,0,1,.63.79,1.07,1.07,0,0,1-.8,1.26,1,1,0,0,1-1.22-.82h0a1.19,1.19,0,0,1,0-.46,7.37,7.37,0,0,1-.93-2.69l-.56.11a3.56,3.56,0,0,0-2.71,4.19l2.4,12.43a.25.25,0,0,0,.24.21h0l10-2.08a.27.27,0,0,0,.2-.32Zm-6.42,8.81,5.1-1,.1.53-5.1,1Zm.46,2.4-.1-.53,5.1-1,.1.54Z",
    transform: "translate(-873.62 -450)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26435",
    "data-name": "Group 26435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26434",
    "data-name": "Group 26434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46842",
    "data-name": "Path 46842",
    d: "M889.6,467.8a.24.24,0,0,1-.14.14l-9.37,4s-.06,0-.1,0h-.1a.25.25,0,0,1-.13-.14l-1-2.19,7.46-1.49a.72.72,0,0,0,.49-.34.73.73,0,0,0,.1-.59l-2.18-11.08a.64.64,0,0,1,.06.14l4.86,11.32A.14.14,0,0,1,889.6,467.8Z",
    transform: "translate(-873.62 -450)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26437",
    "data-name": "Group 26437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26436",
    "data-name": "Group 26436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46843",
    "data-name": "Path 46843",
    d: "M878.91,455.31h0a.51.51,0,0,1-.45-.14,6,6,0,0,1-1.11-3.12c-.1-1,0-2,.45-2.05h.07c.52,0,.9,1,1.11,1.73l-.24,0-.24,0a3.25,3.25,0,0,0-.59-1.28,3.58,3.58,0,0,0,0,1.42,6.67,6.67,0,0,0,.9,2.85A1.91,1.91,0,0,0,878.91,455.31Z",
    transform: "translate(-873.62 -450)",
    fill: "#999"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPromoCode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_promoCode.1ab887756d25366bebc3cfb0f9266c8c.svg";